import { render, staticRenderFns } from "./DocumentCptCodes.vue?vue&type=template&id=1c605404&scoped=true&"
import script from "./DocumentCptCodes.vue?vue&type=script&lang=js&"
export * from "./DocumentCptCodes.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCptCodes.vue?vue&type=style&index=0&id=1c605404&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c605404",
  null
  
)

export default component.exports